export default __webpack_public_path__ + "static/media/login-image.73400759.svg";